/*
 * Texto da IA desenhado como um post: o Markdown passa pelo mesmo formatador
 * do fórum (o s9e TextFormatter que o core carrega para a prévia do editor),
 * então links, listas, código e citações saem iguais aos de um post — e nada
 * de HTML cru do modelo chega à página, porque o formatador o escapa.
 *
 * Durante o streaming o texto muda a cada pedaço; a renderização espera o
 * próximo quadro de animação, para dez pedaços num quadro custarem uma.
 * `streaming` põe o "●" piscando no fim do último parágrafo
 * (`.streamable-content.streaming`).
 */
import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
export default class Cooked extends Component {
  rendered = null;
  frame = 0;
  view() {
    return m("div", {
      className: classList('Post-body CanelaAi-cooked', this.attrs.className, {
        'is-streaming': this.attrs.streaming
      })
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.render();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    if (this.rendered === this.attrs.text || this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      this.render();
    });
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
  render() {
    const element = this.element;
    if (!element) return;
    const text = this.attrs.text || '';
    this.rendered = text;
    if (typeof s9e !== 'undefined' && s9e?.TextFormatter) {
      s9e.TextFormatter.preview(withoutImages(text), element);
    } else {
      element.textContent = text;
    }

    // Imagem que ainda assim saiu (um plugin de auto-imagem, por exemplo) e
    // aponta para fora vira link: carregar sozinha levaria dados da conversa
    // ao servidor de outra pessoa (ver withoutImages).
    element.querySelectorAll('img[src]').forEach(image => {
      let url;
      try {
        url = new URL(image.getAttribute('src') || '', window.location.href);
      } catch {
        image.remove();
        return;
      }
      if (url.host === window.location.host) return;
      const link = document.createElement('a');
      link.href = /^https?:$/.test(url.protocol) ? url.href : '#';
      link.textContent = image.alt || url.href;
      image.replaceWith(link);
    });

    // Links do texto da IA que apontam para fora abrem em outra aba; os do
    // próprio fórum seguem na mesma, como num post.
    element.querySelectorAll('a[href]').forEach(link => {
      if (link.host && link.host !== window.location.host) {
        link.target = '_blank';
        link.rel = 'noopener nofollow ugc';
      }
    });
  }
}

/**
 * As imagens do texto da IA viram links antes de formatar. Uma postagem do
 * fórum pode mandar o modelo escrever `![](https://fora/?d=…)` com dados que só
 * quem pergunta vê; a imagem carregaria sozinha no navegador e entregaria
 * esses dados. Como link, nada sai sem um clique.
 */
function withoutImages(text) {
  return text.replace(/!\[/g, '[').replace(/\[(\/?)img\b/gi, '[$1url');
}
flarum.reg.add('ramon-canela', 'forum/features/ai/Cooked', Cooked);